import React from 'react';
import { ndviColorScale } from '../../utils/ndviColors';
import { ndmiColorScale } from '../../utils/ndmiColors';
import './NdviLegend.css';

const NdviLegend = ({ activeIndex = 'NDVI' }) => {
    const [isOpen, setIsOpen] = React.useState(true);

    // Select appropriate color scale based on active index
    const colorScale = activeIndex === 'NDMI' ? ndmiColorScale : ndviColorScale;
    const indexTitle = activeIndex === 'NDMI' ? 'NDMI (Nem İndeksi)' :
        activeIndex === 'NDRE' ? 'NDRE (Red Edge)' :
            'NDVI (Bitki Sağlığı)';

    return (
        <div className={`ndvi-legend-container ${isOpen ? 'open' : 'collapsed'}`}>
            <div className="ndvi-legend-header" onClick={() => setIsOpen(!isOpen)}>
                <span>{indexTitle}</span>
                <span className="toggle-icon">{isOpen ? '−' : '+'}</span>
            </div>
            {isOpen && (
                <div className="ndvi-legend-scroll-box">
                    <div className="ndvi-legend-gradient">
                        {colorScale.map((item, index) => (
                            <div key={index} className="legend-strip" style={{ backgroundColor: item.color }}>
                                <span className="legend-range">{item.min.toFixed(2)}</span>
                                <span className="legend-label">{item.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default NdviLegend;
